import SolarPanelSummary from "../Common/SolarPanelSummary";
import React from "react";
import Header from "../../layouts/header";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { downloadBudget, getBudgetanalysisData } from "../../api/server";
import { Link, useLocation } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";

const BudgetAnalysisDebts = ({
  thirdParty = false,
  clientId = null,
  params = null,
  summaryData = null,
}) => {
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const retake = Boolean(
    queryParams.get("retake") !== null &&
      queryParams.get("retake") != "null" &&
      queryParams.get("retake") != "false" &&
      queryParams.get("retake") !== false
  );
  const [getloading, setGetLoading] = useState(false);
  // const [showData, setshowData] = useState();
  const [calc, setCal] = useState();
  const [total, setTotal] = useState(0);
  const [updateLoading, setUpdateLoading] = useState(false);

  const handleDownload = async (values) => {
    setUpdateLoading(true);
    try {
      const response = await downloadBudget(
        values.budgetAnalysis.userid,
        values
      );
      if (response) {
        window.open(response.data.documentLink);
        setUpdateLoading(false);
      }
    } catch (error) {
      setUpdateLoading(false);
      toast.error(error.response.data.error);
      console.error("Error updating user data:", error);
    }
  };

  // useEffect(() => {
  //   getBudgetanalysisData(user.user.data.id)
  //     .then((res) => {
  //       setGetLoading(false);
  //       setshowData(res.data);
  //     })
  //     .catch((err) => {
  //       setGetLoading(false);
  //     });
  // }, []);

const storedData = useSelector((state) => state.user.report);
const showData = summaryData || storedData;
const thirdPartyQuery = params ? `?params=${encodeURIComponent(params)}` : "";
const expensesPath = thirdParty
  ? `/course1/budget-analysis-summary/${clientId}/expenses${thirdPartyQuery}`
  : `/budget-analysis-expenses?retake=${retake}`;
const budgetFormPath = thirdParty
  ? `/course1/budget-analysis/${clientId}${thirdPartyQuery}`
  : `/add-info-multistep?retake=${retake}`;
const coursePath = thirdParty
  ? `/course1/${clientId}${thirdPartyQuery}`
  : `/course?retake=${retake}`;
  return (
    <div>
      <div className={`theme_container ${thirdParty ? "" : "mt-250"}`}>
        {!thirdParty && <Header />}
        <h1 className="card-title mb-4">Budget Analysis</h1>
        <section className="breadcrumb-section d-lg-flex justify-content-between align-items-center">
          <nav
            style={{ "--bs-breadcrumb-divider": " '>';" }}
            aria-label="breadcrumb"
          >
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#">Clients Budget Analysis</a>
              </li>
              <li className="breadcrumb-item">Income</li>
              <li className="breadcrumb-item">Expenses</li>
              <li className="breadcrumb-item " aria-current="page">
                Debts
              </li>
            </ol>
          </nav>
          {!getloading && !thirdParty && (
            <button
              className="btn_brnd"
              type="submit"
              disabled={updateLoading}
              onClick={() => {
                handleDownload(showData);
              }}
            >
              {updateLoading ? (
                <ThreeDots
                  height="20"
                  width="217"
                  radius="9"
                  color="#4fa94d"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{
                    display: "block",
                  }}
                  wrapperClassName="spinner"
                  visible={true}
                />
              ) : (
                "Download Budget Analysis"
              )}
            </button>
          )}
        </section>
        <section className="budget-analysis">
          <SolarPanelSummary answers={showData?.Tab4?.solarPanels} />
          {getloading ? (
            <div className="d-flex justify-content-center">
              <ThreeDots
                height="40"
                width="80"
                radius="9"
                color="#4fa94d"
                ariaLabel="three-dots-loading"
                wrapperStyle={{
                  display: "flex",
                  justifyContent: "center",
                }}
                wrapperClassName="spinner"
                visible={true}
              />
            </div>
          ) : (
            <>
              {" "}
              <div className="card main-card">
                <div className="card-body ">
                  <div className="row align-items-center">
                    <div className="col-lg-9">
                      <h6>Paying off your debts.</h6>
                      <p className="my-0">
                        The downside of debt is that it ties up your money so
                        you can't spend or save that money as you wish. It also
                        costs a lot money to borrow money, so plan on paying
                        your debts off as soon as you can.
                      </p>
                      <p className="my-0">
                        One key measurement of your financial health is the
                        debt-to-income ratio or DTI.
                      </p>
                      <p className="my-0">
                        The DTI shows what portion of your gross income goes to
                        pay for:
                      </p>
                      <h6 className="my-0">Housing costs + Debt Payments</h6>
                      <p className="my-0">
                        You should keep at least 2/3 of your gross income free
                        to have the flexibility to cover your monthly expenses.
                        Lending guidelines state that you shouldn't exceed 28%
                        of your gross income for housing and 36% of your gross
                        income for housing plus other debt payments.
                      </p>
                      <p className="my-0">
                        Below is a breakdown of your current monthly payments.
                      </p>
                      <p className="my-0">
                        Don't despair! There are hundreds of solutions to any
                        one problem. We will present all of the major issues
                        with your current financial outlook such as your
                        debt-to-income ratio and spending patterns. We will also
                        offer specific Evergreen Suggestions tailored to your
                        unique situation.
                      </p>
                    </div>
                    <div className="col-lg-3 text-lg-end">
                      <button className="grade-btn btn_brnd mb-2">
                        <span>
                          {showData.Tab4.debtSecFirstData?.debtToIncome?.toFixed(
                            2
                          )}
                          %
                        </span>
                        Your Debt-to-Income ratio.
                      </button>
                      <button className="grade-btn btn_brnd mb-2">
                        <span>
                          {showData.Tab4.debtSecFirstData?.housingToIncome?.toFixed(
                            2
                          )}
                          %
                        </span>
                        Percent of your income just for housing.
                      </button>
                      <button className="grade-btn btn_brnd mb-2">
                        <span>
                          {showData.Tab4.debtSecFirstData?.percentPayment?.toFixed(
                            2
                          )}
                          %
                        </span>
                        Percent of your income just for debt.
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card main-card" style={{overflowX:'auto'}}>
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Creditor</th>
                      <th scope="col">Balance</th>
                      <th scope="col">Payments</th>
                      <th scope="col">Interest Expense</th>
                    </tr>
                  </thead>
                  <tbody>
                    {showData.Tab4.debtSecSecondData.unsecureDebt &&
                      showData.Tab4.debtSecSecondData.unsecureDebt.length > 0 &&
                      showData.Tab4.debtSecSecondData.unsecureDebt.map(
                        (item, index) => (
                          <tr>
                            <td>{item.creditor}</td>
                            <td>
                              ${item.balance} @ {item.interest}% APR
                            </td>
                            <td>
                              ${item.payment} for{" "}
                              {(
                                showData.Tab4.debtSecSecondData?.yearsLeft * 12
                              )?.toFixed(1)}{" "}
                              months
                            </td>
                            <td>
                              $
                              {showData.Tab4.debtSecSecondData?.interestPaidArray[
                                index
                              ]?.toFixed(2)}
                            </td>
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
                <div className="card-body text-center">
                  <h6>Debt Summary</h6>
                  <p className="mb-0">
                    Your current monthly payments are $
                    {showData.Tab4.debtSecSecondData.monthlyPayments}
                  </p>
                  <p className="mb-0">
                    The amount of interest you'll pay for these loans is $
                    {showData.Tab4.debtSecSecondData?.interestTotal?.toFixed(2)}
                  </p>
                  <p>
                    You'll finish paying off these debts in{" "}
                    {showData.Tab4.debtSecSecondData?.yearsLeft?.toFixed(1)}{" "}
                    years
                  </p>
                </div>
              </div>
              <div className="card main-card">
                <div className="card-body ">
                  <h6 className=" ">Paying off your debt faster.</h6>
                  <p>
                    The best way to pay off debt is to list the debts in the
                    order you want to pay them off, then as you pay off each
                    debt, you apply the payment forward to the next debt, and so
                    on.
                  </p>
                  <p>
                    The most often recommended strategy is to payoff your
                    smallest debt first. This is referred to as a 'debt
                    snowball' because you continue to gain momentum as you
                    progress. While you could focus on debts with the highest
                    interest rates, there's nothing that compares to the feeling
                    of accomplishment each time you pay off a debt..
                  </p>
                </div>
                <hr />
                <div className="row ">
                  <div className="col-lg-8 bordr-right">
                    <div className="p-lg-4 p-2">
                      <div className="row mb-4">
                        <div className="col-lg-5">
                          <div className="d-flex align-items-center">
                            <h6 className="text_success me-2 my-0">$</h6>
                            <input
                              type="number"
                              className="form-control"
                              id="exampleInputEmail1"
                              aria-describedby="emailHelp"
                              onChange={(e) => {
                                setCal(e.target.value);
                              }}
                              value={calc}
                            />
                          </div>
                        </div>
                        <div className="col-lg-7">
                          <p>Add more money each month to pay down faster?</p>
                        </div>
                      </div>
                      <div className="row mb-4">
                        <div className="col-lg-5">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option selected>Smallest debit first</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                          </select>
                        </div>
                        <div className="col-lg-7">
                          <p>
                            What order would you like to pay off your debts?
                          </p>
                        </div>
                      </div>
                      <div className="text-center">
                        <button
                          className="btn_brnd"
                          onClick={() => {
                            setTotal(calc);
                          }}
                        >
                          Update Payoff Schedule
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="p-lg-4 p-2">
                      <h6>Paying off your debt faster.</h6>
                      <p>
                        This is what it would look like if you continued to pay
                        ${showData.Tab4.debtSecSecondData.monthlyPayments} every
                        month until your debts are eliminated.
                      </p>
                      <p>
                        You can also see the effect of adding more money each
                        month by entering an amount to the left.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card main-card">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Months</th>
                      <th scope="col">Credit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Months{" "}
                        {(
                          showData.Tab4.debtSecSecondData?.yearsLeft * 12
                        )?.toFixed(1)}
                      </td>
                      <td>
                        $
                        {Number(
                          showData.Tab4.debtSecSecondData.monthlyPayments
                        ) + Number(total)}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="card-body text-center">
                  <h6>Debt Summary</h6>
                  <p className="mb-0">
                    You paid this amount during the debt pay down each month.$
                    {Number(showData.Tab4.debtSecSecondData.monthlyPayments) +
                      Number(total)}
                  </p>
                  <p className="mb-0">
                    The amount of interest you'll pay for these loans is $45,131
                  </p>
                  <p className="mb-0">
                    how much you saved in interest costs is $-66
                  </p>
                  <p>
                    You'll finish paying off these debts in 0 months rather than
                    288
                  </p>
                </div>
              </div>
              <div className="text-center my-4">
                <Link to={expensesPath}>
                  {" "}
                  <a className="text_success mt-4 me-3">
                    <u>Previous</u>
                  </a>
                </Link>
                <Link
                  to={budgetFormPath}
                  className="btn_brnd-outline mt-4 me-3"
                >
                  {" "}
                  Add More Info to My Budget
                </Link>
                <Link to={coursePath}>
                  <button
                    className="btn_brnd mt-4 me-3"
                    //   onClick={() => handleComplete(rank)}
                  >
                    Continue Course
                  </button>
                </Link>
              </div>
            </>
          )}
        </section>
      </div>
    </div>
  );
};

export default BudgetAnalysisDebts;
